import * as yup from 'yup';

import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';
import { getMessage } from '@/features/validation/locales';
import { getNextDay } from '@/utils/dates/dates';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';

export const baseSchema = yup.object({
  zahlweise: yup.string().required().default(''),
  vorversicherung: yup
    .string()
    .required()
    .default('')
    .test(
      'isValidVorversichung',
      getMessage('mixed.required'),
      (value) =>
        !getSimpleChoiceMeta(
          SIMPLE_CHOICE.VORVERSICHERUNG,
          SIMPLE_CHOICE_META.VORVERSICHERUNG_INVALID,
        ).includes(value),
    ),

  versicherungsbeginn: yup.date().default(getNextDay()).required(),
});
